var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProyecto2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000101804740447091284930000002728973276894377369_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.9,477.9H128c-4.7,0-8.5,3.8-8.5,8.5v17.1c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5v-8.5h230.4 c4.7,0,8.5-3.8,8.5-8.5C375.5,481.7,371.6,477.9,366.9,477.9C366.9,477.9,366.9,477.9,366.9,477.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.7,213.3c0,4.7,3.8,8.5,8.5,8.5h34.1c4.7,0,8.5-3.8,8.5-8.5v-51.2c0-4.7-3.8-8.5-8.5-8.5h-34.1 c-4.7,0-8.5,3.8-8.5,8.5L187.7,213.3L187.7,213.3z M204.8,170.7h17.1v34.1h-17.1L204.8,170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.9,102.4H8.5c-4.7,0-8.5,3.8-8.5,8.5v170.7c0.2,4.7,4.1,8.4,8.8,8.2c4.5-0.2,8.1-3.8,8.2-8.2V119.5h93.9 c4.7,0.2,8.7-3.5,8.8-8.2c0.2-4.7-3.5-8.7-8.2-8.8C111.3,102.4,111.1,102.4,110.9,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.6,418.1c0,4.7,3.8,8.5,8.5,8.5h34.1c4.7,0,8.5-3.8,8.5-8.5v-51.2c0-4.7-3.8-8.5-8.5-8.5h-34.1 c-4.7,0-8.5,3.8-8.5,8.5V418.1z M426.7,375.5h17.1v34.1h-17.1V375.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.7,307.2C0.5,307.2,0,417,0,418.1c0,20.3,14.3,37.7,34.1,41.8v43.5c0.2,4.7,4.1,8.4,8.8,8.2 c4.5-0.2,8.1-3.8,8.2-8.2v-43.5c19.9-4.1,34.1-21.5,34.1-41.8C85.3,417,84.8,307.2,42.7,307.2z M42.7,443.7 c-14.1,0-25.6-11.5-25.6-25.6c0-42.5,11.4-93.9,25.6-93.9s25.6,51.4,25.6,93.9C68.3,432.3,56.8,443.7,42.7,443.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.9,256H59.7c-4.7,0-8.5,3.8-8.5,8.5v17.1c0.2,4.7,4.1,8.4,8.8,8.2c4.5-0.2,8.1-3.8,8.2-8.2v-8.5h17.1v42.7 c-0.2,4.7,3.5,8.7,8.2,8.8c4.7,0.2,8.7-3.5,8.8-8.2c0-0.2,0-0.4,0-0.6v-51.2C102.4,259.8,98.6,256,93.9,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.1,221.9h34.1c4.7,0,8.5-3.8,8.5-8.5v-51.2c0-4.7-3.8-8.5-8.5-8.5h-34.1c-4.7,0-8.5,3.8-8.5,8.5v51.2 C409.6,218,413.4,221.9,418.1,221.9z M426.7,170.7h17.1v34.1h-17.1V170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.9,153.6H59.7c-4.7,0-8.5,3.8-8.5,8.5v51.2c0,4.7,3.8,8.5,8.5,8.5h34.1c4.7,0,8.5-3.8,8.5-8.5v-51.2 C102.4,157.4,98.6,153.6,93.9,153.6z M85.3,204.8H68.3v-34.1h17.1V204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.1,213.3c0,4.7,3.8,8.5,8.5,8.5h34.1c4.7,0,8.5-3.8,8.5-8.5v-51.2c0-4.7-3.8-8.5-8.5-8.5h-34.1 c-4.7,0-8.5,3.8-8.5,8.5V213.3z M290.1,170.7h17.1v34.1h-17.1V170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M503.5,102.4H401.1c-4.7-0.2-8.7,3.5-8.8,8.2c-0.2,4.7,3.5,8.7,8.2,8.8c0.2,0,0.4,0,0.6,0h93.9v342.9 c-2.7-1-5.6-1.5-8.5-1.6c-1.5,0-2.9,0.1-4.4,0.4c-9.2-16.4-29.9-22.3-46.4-13.1c-5.5,3.1-10,7.6-13.1,13.1 c-13.9-2.4-27.2,6.9-29.6,20.8c-2.4,13.9,6.9,27.2,20.8,29.6c1.5,0.3,2.9,0.4,4.4,0.4h68.3c14.1,0,25.6-11.5,25.6-25.6V110.9 C512,106.2,508.2,102.4,503.5,102.4z M486.4,494.9h-68.3c-4.7,0-8.5-3.8-8.6-8.5c0-4.7,3.8-8.5,8.5-8.6c1.7,0,3.3,0.5,4.7,1.4 c4,2.6,9.3,1.4,11.8-2.6c0.5-0.8,0.9-1.7,1.1-2.7c2.1-9.2,11.2-14.9,20.4-12.8c6.4,1.5,11.3,6.4,12.8,12.8c0.6,2.7,2.5,5,5.1,6 c2.6,1,5.5,0.8,7.8-0.7c5.5-3.6,13.1,0.8,13.1,7.1C494.9,491.1,491.1,494.9,486.4,494.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.6,119.5h34.1c4.7,0,8.5-3.8,8.5-8.5V59.7c0-4.7-3.8-8.5-8.5-8.5h-34.1c-4.7,0-8.5,3.8-8.5,8.5v51.2 C273.1,115.6,276.9,119.5,281.6,119.5z M290.1,68.3h17.1v34.1h-17.1C290.1,102.4,290.1,68.3,290.1,68.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.1,315.7c0,4.7,3.8,8.5,8.5,8.5h34.1c4.7,0,8.5-3.8,8.5-8.5v-51.2c0-4.7-3.8-8.5-8.5-8.5h-34.1 c-4.7,0-8.5,3.8-8.5,8.5V315.7z M290.1,273.1h17.1v34.1h-17.1V273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,119.5h34.1c4.7,0,8.5-3.8,8.5-8.5V59.7c0-4.7-3.8-8.5-8.5-8.5h-34.1c-4.7,0-8.5,3.8-8.5,8.5v51.2 C187.7,115.6,191.6,119.5,196.3,119.5z M204.8,68.3h17.1v34.1h-17.1V68.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.9,412.1c-3.3,3.3-3.3,8.7,0.1,12.1s8.7,3.3,12.1-0.1c3.3-3.3,3.3-8.7,0-12 C258.6,408.9,253.4,408.9,249.9,412.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.7,315.7c0,4.7,3.8,8.5,8.5,8.5h34.1c4.7,0,8.5-3.8,8.5-8.5v-51.2c0-4.7-3.8-8.5-8.5-8.5h-34.1 c-4.7,0-8.5,3.8-8.5,8.5L187.7,315.7L187.7,315.7z M204.8,273.1h17.1v34.1h-17.1L204.8,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.7,366.9c0,4.7,3.8,8.5,8.5,8.5h25.6v76.8c0.2,4.7,4.1,8.4,8.8,8.2c4.5-0.2,8.1-3.8,8.2-8.2v-76.8h68.3 v76.8c0.2,4.7,4.1,8.4,8.8,8.2c4.5-0.2,8.1-3.8,8.2-8.2v-76.8h25.6c4.7-0.2,8.4-4.1,8.2-8.8c-0.2-4.5-3.8-8.1-8.2-8.2H179.2 C174.5,358.4,170.7,362.2,170.7,366.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.6,315.7c0,4.7,3.8,8.5,8.5,8.5h34.1c4.7,0,8.5-3.8,8.5-8.5v-51.2c0-4.7-3.8-8.5-8.5-8.5h-34.1 c-4.7,0-8.5,3.8-8.5,8.5V315.7z M426.7,273.1h17.1v34.1h-17.1V273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.9,0H145.1c-4.7,0-8.5,3.8-8.5,8.5v443.7c0.2,4.7,4.1,8.4,8.8,8.2c4.5-0.2,8.1-3.8,8.2-8.2V17.1h204.8 v435.2c0.2,4.7,4.1,8.4,8.8,8.2c4.5-0.2,8.1-3.8,8.2-8.2V8.5C375.5,3.8,371.6,0,366.9,0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyecto2);
export default __webpack_public_path__ + "static/media/Proyecto2.1590dd5de5293527fb37d0bf0249a8fa.svg";
export { ForwardRef as ReactComponent };